var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Edit",
    "data-name": "icons/Edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 40,
    height: 40,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-x",
    "data-name": "Icon feather-user-x",
    transform: "translate(6.5 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M17.864,29.045V26.864A4.364,4.364,0,0,0,13.5,22.5H5.864A4.364,4.364,0,0,0,1.5,26.864v2.182",
    transform: "translate(0 -4.909)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M15.477,8.864A4.364,4.364,0,1,1,11.114,4.5a4.364,4.364,0,0,1,4.364,4.364Z",
    transform: "translate(-1.432)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M27,12l5.455,5.455",
    transform: "translate(-6.955 -2.045)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M32.455,12,27,17.455",
    transform: "translate(-6.955 -2.045)",
    fill: "none",
    stroke: "#78849e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUser);
export default __webpack_public_path__ + "static/media/removeUser.fa93551ed4b71fb893330548e7f6949a.svg";
export { ForwardRef as ReactComponent };